<template>
  <span v-if="d" class="csb" :class="'csb-' + d.level"
        :title="'Reigning champion has defended the title ' + d.n + ' time' + (d.n === 1 ? '' : 's') + ' in a row'">
    <span class="csb-fire">{{ d.emoji }}</span>
    <b class="csb-n">{{ d.n }}</b>
    <span class="csb-lbl">streak</span>
    <span v-if="d.word" class="csb-word">{{ d.word }}</span>
  </span>
</template>

<script>
import { streakDisplay } from '../lib/champStreak.js';

export default {
  name: 'ChampStreakBadge',
  props: { streak: { type: Number, default: 0 } },
  computed: { d() { return streakDisplay(this.streak); } },
};
</script>

<style scoped>
/* Base (level 1) — a calm orange pill. Higher tiers escalate size/glow/motion. */
.csb {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  vertical-align: middle;
  margin-left: 6px;
  padding: 1px 8px;
  border-radius: 11px;
  font-size: 12px;
  font-weight: bold;
  color: #ffe08a;
  background: rgba(255, 140, 0, 0.22);
  border: 1px solid #ff8c00;
  white-space: nowrap;
}
.csb-n { font-size: 13px; }
.csb-lbl { font-weight: normal; opacity: 0.85; font-size: 11px; }
.csb-word { text-transform: uppercase; letter-spacing: 0.4px; font-size: 10px; opacity: 0.92; }

/* Level 2 — bolder, hotter. */
.csb-2 { font-size: 13px; color: #ffcf6b; background: rgba(255, 110, 0, 0.26); border-color: #ff7a00; }
.csb-2 .csb-n { font-size: 14px; }

/* Level 3 — gold, glowing, gentle pulse. */
.csb-3 {
  font-size: 14px; color: #ffd700; border-color: #ffb300; background: rgba(255, 150, 0, 0.3);
  text-shadow: 0 0 6px rgba(255, 180, 0, 0.8);
  animation: csb-pulse 1.6s ease-in-out infinite;
}
.csb-3 .csb-n { font-size: 16px; }

/* Level 4 — bigger, hot glow, pulse + flicker. */
.csb-4 {
  font-size: 15px; color: #ffdf3a; border-color: #ff5e00; background: rgba(255, 90, 0, 0.32);
  box-shadow: 0 0 10px rgba(255, 120, 0, 0.6);
  text-shadow: 0 0 8px rgba(255, 170, 0, 0.9);
  animation: csb-pulse 1.1s ease-in-out infinite, csb-flicker 2.4s linear infinite;
}
.csb-4 .csb-n { font-size: 18px; }

/* Level 5 — LEGENDARY: shimmering gradient numerals, deep glow, pulse + shake. */
.csb-5 {
  font-size: 16px; border-color: #ffd700; background: rgba(170, 40, 0, 0.42); color: #ffec80;
  box-shadow: 0 0 16px rgba(255, 140, 0, 0.85), inset 0 0 8px rgba(255, 200, 0, 0.4);
  animation: csb-mega 1.1s ease-in-out infinite;
}
.csb-5 .csb-n { font-size: 20px; }
.csb-5 .csb-n, .csb-5 .csb-word {
  background: linear-gradient(90deg, #ffd700, #ff5e00, #ffec80, #ff8c00, #ffd700);
  background-size: 200% auto;
  -webkit-background-clip: text; background-clip: text;
  -webkit-text-fill-color: transparent; color: transparent;
  animation: csb-shimmer 2s linear infinite;
}

@keyframes csb-pulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.07); } }
@keyframes csb-flicker { 0%, 100% { filter: brightness(1); } 45% { filter: brightness(1.3); } 55% { filter: brightness(0.9); } }
@keyframes csb-shimmer { to { background-position: 200% center; } }
/* one combined transform so scale + shake don't fight (two transform animations would override) */
@keyframes csb-mega {
  0%, 100% { transform: scale(1) rotate(0); }
  25% { transform: scale(1.05) rotate(-2.5deg); }
  50% { transform: scale(1.09) rotate(0); }
  75% { transform: scale(1.05) rotate(2.5deg); }
}

@media (prefers-reduced-motion: reduce) {
  .csb-3, .csb-4, .csb-5, .csb-5 .csb-n, .csb-5 .csb-word { animation: none; }
}
</style>
